/*
 * @Author: DT
 * @Date: 2022-08-01 11:42:46
 * @LastEditors: DT
 * @LastEditTime: 2022-08-01 13:49:38
 * @Description: file content
 * @FilePath: /yxdcommunity/src/views/others/index.js
 */
// export { default as pageLost } from './pageLost/pageLost.vue';
// export { default as positionLost } from './positionLost/positionLost.vue';

export const positionLost = (r) => require.ensure([], () => r(require("./positionLost/positionLost.vue")), "positionLost");
export const pageLost = (r) => require.ensure([], () => r(require("./pageLost/pageLost.vue")), "pageLost");
export const indexPick = (r) => require.ensure([], () => r(require("./indexPick/indexPick.vue")), "indexPick");
